export default __webpack_public_path__ + "static/media/see-more.9891837b.svg";